module.exports = __webpack_public_path__ + "static/media/cut-scene.558958fe.svg";